import { App } from './app'
import { ALLIANZ_VARS } from './config'
import { isFormLanding } from './helpers/isFormLanding'
import { loadScript } from './helpers/loadScripts'

function LOAD_ENVIROMENT() {
  const URL = window.location.href

  if (URL.includes('walmericTest=int')) {
    return loadScript(ALLIANZ_VARS.paths.testEnviroment)
  }

  if (!isFormLanding()) {
    App()
  }
}
LOAD_ENVIROMENT()
const version = '3.3.6'
const updateDate = '17/05/2024'
console.info(`Cargada la versión ${version} actualizada el ${updateDate}`)
